
import {defineComponent} from 'vue'

export default defineComponent({
  name: "BaseOffcanvasButtonOpen",
  props: {
    offcanvasId: {
      type: String,
      required: true
    },
    class: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['beforeOpen'],
  methods: {
    handleClick(event: Event) {
      // Emit an event to the parent component so it can execute custom logic
      this.$emit('beforeOpen', event);
    }
  }
})
